/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FollowedCompanyResponse } from '../../models/followed-company-response';
import { GetCompaniesNearMeRequest } from '../../models/get-companies-near-me-request';

export interface GetCompaniesNearMe$Params {
      body: GetCompaniesNearMeRequest
}

export function getCompaniesNearMe(http: HttpClient, rootUrl: string, params: GetCompaniesNearMe$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FollowedCompanyResponse>>> {
  const rb = new RequestBuilder(rootUrl, getCompaniesNearMe.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FollowedCompanyResponse>>;
    })
  );
}

getCompaniesNearMe.PATH = '/api/companies-near-me';
